import GlobalSearch from "./GlobalSearch";

export default GlobalSearch